import { render, staticRenderFns } from "./EditFhirClientSidebar.vue?vue&type=template&id=17ecdb2d&scoped=true&"
import script from "./EditFhirClientSidebar.vue?vue&type=script&lang=ts&"
export * from "./EditFhirClientSidebar.vue?vue&type=script&lang=ts&"
import style0 from "./EditFhirClientSidebar.vue?vue&type=style&index=0&id=17ecdb2d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17ecdb2d",
  null
  
)

export default component.exports